import Price from '~/libs/Price/Price';

import PriceOrigin from './PriceOrigin';
import PriceOriginComputed from './PriceOriginComputed';
import ProductPrice from './ProductPrice';

export interface RawProductPrice {
	type: string;
	value: string;
	currency: string;
	priority: number;
	origin:
		| {
				type: string;
				computed: { basedOnPriceType: string; calculationType: string } | null;
		  }
		| undefined;
}

export default function mapProductPrice(productPrice: RawProductPrice): ProductPrice {
	return new ProductPrice(
		productPrice.type,
		new Price(productPrice.value, productPrice.currency),
		productPrice.priority,
		productPrice.origin !== undefined
			? new PriceOrigin(
					productPrice.origin.type,
					productPrice.origin.computed !== null
						? new PriceOriginComputed(
								productPrice.origin.computed.basedOnPriceType,
								productPrice.origin.computed.calculationType
						  )
						: null
			  )
			: null
	);
}
